import { PricePlanType } from '@systemeio/types'
import { centsToUnits } from '@systemeio/util'
import { PricePlanDetails } from 'modules/digital-product/price-plans/components/price-plan-details'
import { pricePlanTypeLocoKeys } from 'modules/digital-product/price-plans/constants/price-plan-type-loco-keys'
import React, { ReactNode } from 'react'
import { Hint } from 'shared/components'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import useUser from 'shared/hooks/use-user'
import { currencyFormat } from 'shared/utils/currency-format'
import { twMerge } from 'tailwind-merge'

interface PricePlanRowProps {
  actions?: ReactNode
  className?: string
  pricePlan: PricePlanType
}

/**
 * Read-only summary of a single price plan: name, type and amount.
 */
export function PricePlanRow({ actions, className, pricePlan }: PricePlanRowProps) {
  const { t } = useLocoTranslation()
  const { user } = useUser()

  const amount = currencyFormat(
    centsToUnits(pricePlan.amount),
    pricePlan.currency,
    user?.dashboardLocale,
  )

  return (
    <div
      className={twMerge(
        'border-border-100 flex items-center justify-between gap-3 rounded-lg border p-3',
        className,
      )}
    >
      <div className={'min-w-0'}>
        <div className={'flex items-center gap-1'}>
          <span className={'truncate text-base font-medium'}>{pricePlan.innerName}</span>
          <Hint
            ariaLabel={pricePlan.innerName}
            label={<PricePlanDetails pricePlan={pricePlan} variant="rows" />}
          />
        </div>
        <p className={'text-text-secondary truncate text-sm'}>
          {t(pricePlanTypeLocoKeys[pricePlan.type])}
        </p>
      </div>
      <div className={'flex shrink-0 items-center gap-5'}>
        <span className={'text-lg font-semibold'}>{amount}</span>
        {actions}
      </div>
    </div>
  )
}
